import { z } from 'zod';

import { FlowRunState } from './flowRun.js';
import { oneOrMany } from '../../utils.js';

const _flowRunExploreFindAllRequestQuerySchema = z.object({
  flowId: z.string().uuid(),
  limit: z.coerce.number().optional(),
  offset: z.coerce.number().optional(),
  createdBefore: z.string().datetime().optional(),
  createdAfter: z.string().datetime().optional(),
  startedBefore: z.string().datetime().optional(),
  startedAfter: z.string().datetime().optional(),
  endedBefore: z.string().datetime().optional(),
  endedAfter: z.string().datetime().optional(),
  orderBy: z.string().optional(),
  orderDirection: z.enum(['asc', 'desc']).optional(),
  state: oneOrMany(z.nativeEnum(FlowRunState)).optional(),
  groupId: z.string().uuid().optional(),
});

const _flowRunExploreGetColumnsRequestQuerySchema = z.object({
  flowId: z.string().uuid(),
});

const flowRunExploreColumnTypeSchema = z.enum(['FlowRun', 'BlockOutput']);

const flowRunExploreColumnSchema = z.object({
  key: z.string(),
  displayName: z.string(),
  type: flowRunExploreColumnTypeSchema,
});

const flowRunExploreRequestColumnSchema = flowRunExploreColumnSchema.partial({
  displayName: true,
});

const _flowRunExploreExportRequestSchema = _flowRunExploreFindAllRequestQuerySchema
  .partial({
    limit: true,
    offset: true,
  })
  .extend({
    columns: z.array(flowRunExploreRequestColumnSchema),
  });

const _flowRunExploreGetColumnsResponseSchema = z.object({
  columns: z.array(flowRunExploreColumnSchema),
});

const _flowRunExploreExportResponseSchema = z.object({
  spreadsheetId: z.string().nullish(),
  spreadsheetUrl: z.string().nullish(),
});

type FlowRunExploreColumnType = z.infer<typeof flowRunExploreColumnTypeSchema>;

export type FlowRunExploreColumn = z.infer<typeof flowRunExploreColumnSchema>;

export type FlowRunExploreRequestColumn = z.infer<typeof flowRunExploreRequestColumnSchema>;

export type FlowRunExploreFindAllOptions = z.infer<typeof _flowRunExploreFindAllRequestQuerySchema>;

export type FlowRunExploreGetColumnsOptions = z.infer<
  typeof _flowRunExploreGetColumnsRequestQuerySchema
>;

export type FlowRunExploreExportOptions = z.infer<typeof _flowRunExploreExportRequestSchema>;

export interface FlowRunExploreFindAllResponse {
  data: {
    id: string;
    [key: `${FlowRunExploreColumnType}:${string}`]: { value: unknown };
  }[];
  columns: FlowRunExploreColumn[];
}

export type FlowRunExploreGetColumnsResponse = z.infer<
  typeof _flowRunExploreGetColumnsResponseSchema
>;

export type FlowRunExploreExportResponse = z.infer<typeof _flowRunExploreExportResponseSchema>;
export interface FlowRunExploreDownloadResponse {
  downloadUrl: string;
}
